import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const BellIcon  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>;
const UserIcon  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const SearchIcon= () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;

const NOTIFICATIONS = [
  { id: 1, text: 'New meeting created successfully', time: '2m ago', dot: 'orange' },
  { id: 2, text: 'Translation engine updated to v2.1', time: '1h ago', dot: 'teal' },
  { id: 3, text: 'Socket connection stable', time: '2h ago', dot: 'green' },
];

const Header = ({ collapsed, pageTitle, pageSubtitle }) => {
  const [notifOpen, setNotifOpen]   = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();
  const unread = 2;
  const loginEmail = localStorage.getItem('loginEmail') || '';
  const role = localStorage.getItem('loginRole') || 'user';

  const handleSignOut = (e) => {
    e.preventDefault();
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('loginEmail');
    localStorage.removeItem('loginRole');
    localStorage.removeItem('loginTime');
    navigate('/login');
  };

  return (
    <header className="app-header" style={{ left: collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)' }}>

      {/* Left */}
      <div className="hdr-left">
        <div className="hdr-page-info">
          <h1 className="hdr-page-title">{pageTitle || 'Dashboard'}</h1>
          {pageSubtitle && <p className="hdr-page-sub">{pageSubtitle}</p>}
        </div>
      </div>

      {/* Right */}
      <div className="hdr-right">

        {/* Search */}
        <div className="hdr-search">
          <SearchIcon/>
          <input type="text" placeholder="Search..." />
        </div>

        {/* Notifications */}
        <div className="hdr-btn-wrap">
          <button className="hdr-icon-btn" onClick={() => { setNotifOpen(!notifOpen); setProfileOpen(false); }}>
            <BellIcon/>
            {unread > 0 && <span className="hdr-badge">{unread}</span>}
          </button>
          {notifOpen && (
            <div className="hdr-dropdown notif-dropdown">
              <div className="dd-header">
                <span className="dd-title">Notifications</span>
                <span className="dd-count">{unread} new</span>
              </div>
              {NOTIFICATIONS.map(n => (
                <div className="dd-item" key={n.id}>
                  <span className={`dd-dot dot-${n.dot}`}/>
                  <div>
                    <p className="dd-item-text">{n.text}</p>
                    <p className="dd-item-time">{n.time}</p>
                  </div>
                </div>
              ))}
              <div className="dd-footer">View all notifications</div>
            </div>
          )}
        </div>

        {/* Profile */}
        <div className="hdr-btn-wrap">
          <button className="hdr-profile-btn" onClick={() => { setProfileOpen(!profileOpen); setNotifOpen(false); }}>
            <div className="hdr-avatar">
              <UserIcon/>
            </div>
            <div className="hdr-profile-info">
              <span className="hdr-profile-name">{role === 'admin' ? 'Admin' : 'User'}</span>
              <span className="hdr-profile-role">{role === 'admin' ? 'Meeting Host' : 'Participant'}</span>
            </div>
            <svg className="hdr-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 9l6 6 6-6"/>
            </svg>
          </button>
          {profileOpen && (
            <div className="hdr-dropdown profile-dropdown">
              <div className="dd-profile-top">
                <div className="dd-profile-avatar"><UserIcon/></div>
                <div>
                  <p className="dd-profile-name">{role === 'admin' ? 'Admin User' : 'Meeting Participant'}</p>
                  <p className="dd-profile-email">{loginEmail}</p>
                </div>
              </div>
              <hr className="dd-hr"/>
              {role === 'admin' && <a href="/settings" className="dd-link">⚙️ &nbsp;Settings</a>}
              <a href="#signout" className="dd-link dd-link-danger" onClick={handleSignOut}>🚪 &nbsp;Sign Out</a>
            </div>
          )}
        </div>

      </div>

      {/* Backdrop */}
      {(notifOpen || profileOpen) && (
        <div className="hdr-backdrop" onClick={() => { setNotifOpen(false); setProfileOpen(false); }}/>
      )}
    </header>
  );
};

export default Header;
